import { Injectable } from '@angular/core';
import { PlatformApiWpService } from './platform-apiwp.service';
import { catchError, of, takeUntil, throwError } from 'rxjs';
import { HttpErrorResponse, HttpEvent, HttpEventType, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ProductService } from './product.service';

@Injectable({
  providedIn: 'root'
})
export class PlaymetricsService {
  
  playmetricsBuyed!: boolean;
  havePlaymetricsPromise: Promise<boolean> | null = null;

  constructor(
    private platformApiWpService: PlatformApiWpService,
    private productService: ProductService,
  ) {
   }

  havePlaymetrics(): Promise<boolean> {

    if(this.havePlaymetricsPromise)
      return this.havePlaymetricsPromise;

    this.havePlaymetricsPromise = new Promise((resolve, reject) => {

      if(this.playmetricsBuyed !== undefined) {
        resolve(this.playmetricsBuyed);
      }
      this.productService.getProducts({getVariations: true}).then((products: any) => {
        console.log(products);
        const playmetrics = products.find((product: any) => product.sku === 'playmetrics' && product.is_purchased);
        if (playmetrics) {
          this.playmetricsBuyed == true;
          resolve(true);
          setTimeout(() => {
              this.havePlaymetricsPromise = null;
          }, 200);
          return;
        }
        this.playmetricsBuyed == false;
        resolve(false);
        setTimeout(() => {
          this.havePlaymetricsPromise = null;
      }, 200);
      });
    })

    return this.havePlaymetricsPromise;
    
  }

  getRequest(preventError?: boolean, preventLoader?: boolean) {
    return new Promise((resolve, reject) => {
      this.platformApiWpService.getRequest('playmetrics/v1/request', null, preventError, preventLoader).then((sub) => {
        sub
          .pipe(
            catchError((err) => {
              console.log(err);
              reject(err);
              return throwError(() => err);
            })
          )
          .subscribe((response: any) => {
            console.log(response);
            resolve(response);
          })
      });
    })
  }

  getMetrics() {
    return new Promise((resolve, reject) => {
      this.platformApiWpService.getRequest('playmetrics/v1/metrics').then((sub) => {
        sub
          .pipe(
            catchError((err) => {
              console.log(err);
              reject(err);
              return throwError(() => err);
            })
          )
          .subscribe((response: any) => {
            console.log(response);
            resolve(response);
          })
      });
    })
  }

  uploadVideo(videoBlob: Blob, name?: string) {
    return new Promise((resolve, reject) => {
      if (!name) {
        name = 'video.mp4';
      }

      const formData = new FormData();
      formData.append('file', videoBlob, name);

      this.platformApiWpService.postFileRequest('playmetrics/v1/upload_video', formData)
        .then((sub) => {
          sub
            .pipe(
              catchError((err) => {
                console.log(err);
                reject(err);
                return throwError(() => err);
              })
            )
            // .subscribe((response: any) => {
            //   console.log(response);
            //   if (response && response.status == 'ok' && response.payload) {
            //     resolve(response)
            //   } else {
            //     reject(response)
            //   }
            // })
            .subscribe({
              next: (event: HttpEvent<any>) => {
                if (event.type === HttpEventType.Response) {
                  // Operazioni sul JSON quando l'upload è completato
                  const responseBody = event.body;
                  console.log(responseBody);
                  // Esegui altre operazioni sul JSON qui
                }
              },
              error: (err: any) => {
                console.error('Errore durante l\'upload:', err);
              },
              complete: () => {
                console.log('Upload completato');
                resolve(true);
              }
            })
        })
    })

  }

  startPlaymetrics(videoDescription: string) {
    return new Promise((resolve, reject) => {
      this.platformApiWpService.postRequest('playmetrics/v1/start', {
        'video_description': videoDescription,
      }).then((sub) => {
        sub
          .pipe(
            catchError((err) => {
              console.log(err);
              reject(err);
              return throwError(() => err);
            })
          )
          .subscribe((response: any) => {
            console.log(response);
            resolve(response);
          })
      });
    })

  }

  getStreamUrl() {
    return new Promise((resolve, reject) => {
      this.platformApiWpService.getRequest('playmetrics/v1/stream_url').then((sub) => {
        sub
          .pipe(
            catchError((err) => {
              console.log(err);
              reject(err);
              return throwError(() => err);
            })
          )
          .subscribe((response: any) => {
            console.log(response);
            resolve(response);
          })
      });
    })

  }

  buildStreamUrl(keyId: string): string {
    return this.platformApiWpService.getOrigin() + '/playmetrics/stream?keyId=' + keyId;
  }

  downloadReport() {
    return new Promise((resolve, reject) => {

      this.platformApiWpService.setHeaders().then((h: HttpHeaders) => {
        this.platformApiWpService.getRawRequest(this.platformApiWpService.getBaseUrl() +'/playmetrics/v1/download_report', { headers: h, observe: 'body', responseType: 'blob' }, true, true)
      .pipe(
            catchError((err: HttpErrorResponse) => {
              console.log('error', err);
              // this.snackBar.open('Errore nel download del Report. Riprova piu tardi.', 'Chiudi', {
              //   duration: 3000
              // });
              // this.downloadingPreview = false;
              // if (this.loadertype == 'global') {
              //   this.loaderService.hideLoader();
              // } else {
              //   this.downloadingProgress = false;
              // }
              reject(err);
              return of(err);
            })
          )
        .subscribe((response: any) => {
              // Perform your actions here
              // Then start the actual download
              // if (response.ok) {
         
            let url = window.URL.createObjectURL(response);
              
                const link = document.createElement('a');
          link.href = url;
          let label = 'playmetrics_report.pdf';
                link.setAttribute('download', label);
                document.body.appendChild(link);
                link.click();
                link.remove();
                resolve(true);
              //  }
              // this.downloadingPreview = false;
              // if (this.loadertype == 'global') {
              //   this.loaderService.hideLoader();
              // } else {
              //   this.downloadingProgress = false;
              //   this.downloadComplete = true;
              //    setTimeout(() => {
              //      this.downloadComplete = false;
              //      this.cdr.detectChanges();
              // },1000);
              });
             
          });

      // this.platformApiWpService.getRequest('playmetrics/v1/download_report').then((sub) => {
      //   sub
      //     .pipe(
      //       catchError((err) => {
      //         console.log(err);
      //         reject(err);
      //         return throwError(() => err);
      //       })
      //     )
      //     .subscribe((response: any) => {
      //       console.log(response);
      //       resolve(response);
      //     })
      // });
    })

  }


  downloadVideo(url: any) {
    return this.platformApiWpService.http.get(url, { responseType: 'blob' })
  }


}
